import React from "react";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

export const SectionThree = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const cardsData = [
    {
      icon: "assets/images/keinternational/xplosive.svg",
      headline: "Founder, Xplosive Ape",
      cta:
        "“With KwikEngage, we’ve recovered over 22% of abandoned carts and seen a clear uplift in revenue. The 13X ROI on our WhatsApp spend speaks for itself — fast, effective, and truly personal.”",
    },
    {
      icon: "assets/images/keinternational/firebolt.svg",
      headline: "Arnav Kishore, Founder & CEO",
      cta:
        "KwikEngage helped us cut acquisition costs by 40% and generate 3.4L+ leads in just 45 days. We also saw a 2X boost in cart recovery. Super impressed with the results.",
    },
  ];

  return (
    <div className="section-3a">
      {
        !isMobile ? (
          <Swiper
            centeredSlides={true}
            grabCursor={true}
            slidesPerView={1}
            spaceBetween={30}
            loop={false}
            pagination={{ clickable: true }}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            modules={[Pagination, Autoplay]}
            style={{
              width: "100%",
              maxWidth: 1000,
              minHeight: 360,
            }}
            breakpoints={{
              320: {
                slidesPerView: 1,
                spaceBetween: 2,

              },
              768: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
              1024: {
                slidesPerView: 1,
                spaceBetween: 10,
              },
            }}
          >
            {cardsData.map((card, idx) => (
              <SwiperSlide key={idx}>
                <div className="testimonial-content">
                  <div className="testimonial-text">{card.cta}</div>
                  <img
                    src={card.icon}
                    alt={`Logo of ${card.headline}`}
                    className="testimonial-icon"
                    loading="lazy"
                  />
                  <div className="testimonial-headline">{card.headline}</div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div>
            {cardsData.map((card, idx) => (

              <div className="testimonial-content">
                <div className="testimonial-text">{card.cta}</div>
                <img
                  src={card.icon}
                  alt={`Logo of ${card.headline}`}
                  className="testimonial-icon"
                  loading="lazy"
                />
                <div className="testimonial-headline">{card.headline}</div>
              </div>

            ))}
          </div>
        )
      }
    </div>
  );
};
